<template>
  <v-dialog :id="id" v-model="modalShow" :max-width="size" lazy persistent>
    <v-card>
      <v-card-title class="headline primary white--text" v-if="title"> {{ title }}</v-card-title>
      <v-card-title v-if="!title">
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text>
        <!-- El componente será destruido o recreado -->
        <slot v-if="modalShow"></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    id: {
      type: String,
      required: true
    },
    modalShow: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      required: false,
      default: 'auto'
    },
    title: {
      type: String,
      required: false
    }
  }
};
</script>
